import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { CommonCMS } from "@lib/constants/contentful";
import { BoxWithRibbon } from "../BoxWithRIbbon";

const FailedEmailVerification = ({ microcopies }) => {
    return (
        <BoxWithRibbon>
            <Box padding={[6, 8]}>
                <Text fontWeight="bold" fontSize="desktopH2">
                    {microcopies[CommonCMS.loyalty.emailVerification.failed]}
                </Text>
            </Box>
        </BoxWithRibbon>
    );
};

export default FailedEmailVerification;
